import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteRomaneioColheita } from '../service';
import {
  DELETE_ROMANEIO_COLHEITA,
  DELETE_ROMANEIO_COLHEITA_PENDING,
  DELETE_ROMANEIO_COLHEITA_SUCCESS,
  DELETE_ROMANEIO_COLHEITA_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'

function* sagaDeleteRomaneioColheita(action) {
  yield put({ type: DELETE_ROMANEIO_COLHEITA_PENDING, id: action.id })

  try {
    const a = yield call(deleteRomaneioColheita, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_ROMANEIO_COLHEITA_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_ROMANEIO_COLHEITA_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeleteRomaneioColheita() {
  yield takeLatest(DELETE_ROMANEIO_COLHEITA, sagaDeleteRomaneioColheita)
}
